import { z } from 'zod';
import { id } from '../atomic/id';

export const tagSchema = z.object({
  id,
  name: z.string(),
});